import { connect } from "react-redux";
import ProjectTile from "common/components/project_tile";

const mapStateToProps = ({ admin }) => {
  const { titleWords } = admin.projects;

  return {
    titleWords,
  };
};

export default connect(mapStateToProps)(ProjectTile);
